import { render, staticRenderFns } from "./app-down.vue?vue&type=template&id=5a20f994&scoped=true&"
import script from "./app-down.vue?vue&type=script&lang=js&"
export * from "./app-down.vue?vue&type=script&lang=js&"
import style0 from "./app-down.vue?vue&type=style&index=0&id=5a20f994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20f994",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VContainer,VDialog})
